// extracted by mini-css-extract-plugin
module.exports =  {"NoData":"NoData__KIqPM"};